import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

export const PlusIcon = (props: IconContainerProps): JSX.Element => {
  const theme = useTheme();

  const AthletaSVG = (
    <svg viewBox="0 0 12.87 13" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.43 0h2v13h-2z" />
      <path d="M12.87 5.5v2H0v-2z" />
    </svg>
  );

  const BananaRepublicSVG = (
    <svg fill="none" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M7 0H5v5H0v2h5v5h2V7h5V5H7V0z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );

  const GapSVG = (
    <svg fill="none" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M7 0H5v5H0v2h5v5h2V7h5V5H7V0z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );

  const OldNavySVG = (
    <svg viewBox="0 0 10.5 10.5" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.75 4.125H6.375V.75a.75.75 0 00-.75-.75h-.75a.75.75 0 00-.75.75v3.375H.75a.75.75 0 00-.75.75v.75a.75.75 0 00.75.75h3.375V9.75a.75.75 0 00.75.75h.75a.75.75 0 00.75-.75V6.375H9.75a.75.75 0 00.75-.75v-.75a.75.75 0 00-.75-.75z"
        fill={theme.color.b1}
      />
    </svg>
  );

  const CrossBrandSVG = (
    <svg fill="none" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M7 0H5v5H0v2h5v5h2V7h5V5H7V0z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: AthletaSVG,
    [Brands.BananaRepublic]: BananaRepublicSVG,
    [Brands.BananaRepublicFactoryStore]: BananaRepublicSVG,
    [Brands.Gap]: GapSVG,
    [Brands.GapFactoryStore]: GapSVG,
    [Brands.OldNavy]: OldNavySVG,
    crossBrand: CrossBrandSVG,
  };

  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
